export const supportedLanguages = ['en', 'kr', 'jp'] as const

export type SupportedLanguage = typeof supportedLanguages[number]

const languageMap: Record<string, SupportedLanguage> = {
  en: 'en',
  'en-au': 'en',
  'en-gb': 'en',
  'en-uk': 'en',
  'en-us': 'en',
  ja: 'jp',
  'ja-jp': 'jp',
  jp: 'jp',
  ko: 'kr',
  'ko-kr': 'kr',
  kr: 'kr',
}

const normalizeLanguage = (
  language?: string | null
): SupportedLanguage | null => {
  if (!language) return null

  const normalizedLanguage = language.trim().toLowerCase()

  return languageMap[normalizedLanguage] || null
}

const getStoredLanguage = (): SupportedLanguage | null =>
  normalizeLanguage(localStorage.getItem('language'))

const getBrowserLanguage = (): SupportedLanguage | null =>
  normalizeLanguage(navigator.language) ||
  normalizeLanguage(navigator.language.split('-')[0])

const getDocumentLanguage = (language: SupportedLanguage): string => {
  switch (language) {
    case 'kr':
      return 'ko'
    case 'jp':
      return 'ja'
    default:
      return 'en'
  }
}

const resolveInitialLanguage = (): SupportedLanguage =>
  getStoredLanguage() || getBrowserLanguage() || 'en'

export {
  getBrowserLanguage,
  getDocumentLanguage,
  getStoredLanguage,
  normalizeLanguage,
  resolveInitialLanguage,
}
